import React, { useEffect, useRef } from 'react';
import './GearFooter.css';
import twitter from 'asset/icon/ic_sns_twitter.png';
import telegram from 'asset/icon/ic_sns_telegram.png';
import discord from 'asset/icon/ic_sns_discord.png';
import medium from 'asset/icon/ic_sns_medium.png';
import facebook from 'asset/icon/ic_sns_facebook.png';
import youtube from 'asset/icon/ic_sns_youtube.png';
import social from 'asset/icon/ic_sns_white_paper.png';
import scrollBtn from 'asset/icon/ic_scorll_white_40dp.svg';

const createScrollStopListener = (element, callback, timeout) => {
  let removed = false;
  let handle = null;
  const onScroll = () => {
    document.querySelector('.scrolling-wrap')?.classList.add('disable');
    document.querySelector('.scroll-btn')?.classList.remove('show');
    if (handle) {
      clearTimeout(handle);
    }

    handle = setTimeout(callback, timeout || 200); // default 200 ms
  };
  element.addEventListener('scroll', onScroll);
  return () => {
    if (removed) {
      return;
    }
    removed = true;
    if (handle) {
      clearTimeout(handle);
    }
    element.removeEventListener('scroll', onScroll);
  };
};

const useScrollStopListener = (element, callback, timeout) => {
  const callbackRef = useRef();
  callbackRef.current = callback;
  useEffect(() => {
    const destroyListener = createScrollStopListener(element, () => {
      if (callbackRef.current) {
        callbackRef.current();
      }
    });
    return () => destroyListener();
  }, [element]);
};
function GearFooter(props) {
  useScrollStopListener(window, () => {
    const scrollTop = window.scrollY;
    const innerHeight = window.innerHeight;
    const scrollHeight = document.querySelector('body').scrollHeight;

    if (scrollTop > 100) {
      document.querySelector('.scroll-btn').classList.add('show');
    }

    if (scrollTop + innerHeight + 100 >= scrollHeight) {
      document.querySelector('.scroll-btn').style.bottom = '100px';
      return true;
    } else {
      document.querySelector('.scroll-btn').style.bottom = '20px';
      document.querySelector('.scrolling-wrap').classList.remove('disable');
    }
  });
  return (
    <div className={'channel-wrap'}>
      <p className={'channel-copyright'}>
        Copyright © Blockbusterlab Inc. All rights reserved.
      </p>
      <a
        className={'channel-mail'}
        href="mailto:contact@perplay.io"
      >
        contact@perplay.io
      </a>
      <div className={'channel-icon-list'}>
        <a
          href="https://twitter.com/PERPLAYofficial"
          className="btn-social btn-social--twitter"
          title="Twitter"
        >
          <img
            className={'channel-icon'}
            src={twitter}
            alt={'twitter'}
          />
        </a>
        <a
          href="https://discord.com/invite/PERPLAY"
          className="btn-social btn-social--discord"
          title="Discord"
        >
          <img
            className={'channel-icon'}
            src={discord}
            alt={'discord'}
          />
        </a>
        <a
          href="https://medium.com/@PERPLAY"
          className="btn-social btn-social--medium"
          title="Medium"
        >
          <img
            className={'channel-icon'}
            src={medium}
            alt={'medium'}
          />
        </a>
        <a
          href="https://t.me/PERPLAY"
          className="btn-social btn-social--telegram"
          title="Telegram"
        >
          <img
            className={'channel-icon'}
            src={telegram}
            alt={'telegram'}
          />
        </a>
        <a
          href="https://www.facebook.com/PERPLAYofficial"
          className="btn-social btn-social--facebook"
          title="facebook"
        >
          <img
            className={'channel-icon'}
            src={facebook}
            alt={'facebook'}
          />
        </a>
        <a
          href="https://www.youtube.com/@perplay"
          className="btn-social btn-social--youtube"
          title="youtube"
        >
          <img
            className={'channel-icon'}
            src={youtube}
            alt={'youtube'}
          />
        </a>
        <a
          href="https://docs.perplay.io/"
          className="btn-social btn-social--page"
          title="WhitePaper"
        >
          <img
            className={'channel-icon'}
            src={social}
            alt={'social'}
          />
        </a>
      </div>
      <div className="scrolling-wrap">
        <div className="chevron"></div>
        <div className="chevron"></div>
        <div className="chevron"></div>
      </div>
      <img
        className={'scroll-btn'}
        src={scrollBtn}
        alt={'scorll'}
        onClick={() => {
          window.scrollTo(0, 0);
        }}
      />
    </div>
  );
}

export default GearFooter;
